import { withdrawBiddingBlockBidGroup } from '@ebalance/proto/bffuser/v1/bidding_block_service-BiddingBlockService_connectquery'

import { blockApprovalRequestInvalidationKeys } from '~/hooks/bidding/queryKeys'
import { useWorkflowCaseScopedMutation } from '~/hooks/bidding/useWorkflowCaseScopedMutation'
import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * 入札中のブロック入札グループの取下 mutation hook (AC-BSP-057)。
 */
export function useWithdrawBiddingBlockBidGroup(): InvalidatingMutationResultFor<
  typeof withdrawBiddingBlockBidGroup
> {
  return useWorkflowCaseScopedMutation(
    useInvalidatingMutation(
      withdrawBiddingBlockBidGroup,
      blockApprovalRequestInvalidationKeys,
    ),
  )
}
